import { ApiClient } from '@webapp/core/services/ApiClient'
import { FinancialAccountRepository } from './FinancialAccountRepository'

export const financialAccountRepository = new FinancialAccountRepository({
  httpClient: ApiClient,
})
